/**
 * @module @bingads-webui/projection-grid-toolbar
 */

import { toolbarPlugin } from './src/toolbar-plugin';
import { constants } from './src/constants';
import { helpers } from './src/helpers';

/**
 * The version of the module
 */

export {
  /**
   * The projection-grid plugin to create toolbars and associate them with the
   * grid. The config object is a hash of ToolbarView constructor options
   * ({@link ToolbarPluginConfig}). The product of this plugin is a
   * {@link ToolbarPluginProduct} object.
   */
  toolbarPlugin,

  /**
   * The constants used by the toolbar plugin
   * @property {string} TOOLBAR_ROW_TYPE -
   *    The predefined row type for toolbars
   * @property {string} DEFAULT_TOOLBAR_NAME -
   *    The default toolbar name for single toolbar cases
   */
  constants,

  /**
   * The helper functions used to config the toolbar plugin
   * @property {function} toolbarRow -
   *    Helper function to generate the projection-grid row config for a
   *    toolbar, refer to {@link toolbarRow}.
   * @property {function} singleToolbarHeadRows -
   *    Helper function to generate the projection-grid headRows config for the
   *    single toolbar cases, refer to {@link singleToolbarHeadRows}.
   * @property {function} singleToolbar -
   *    Helper function to generate the toolbar plugin config for the single
   *    toolbar cases, refer to {@link singleToolbar}.
   */
  helpers,
};
